export default errorForm => {
  const errorFormNormalized = {};
  Array.from(errorForm).forEach(error => {
    errorFormNormalized[error.field] = error.message;
  });
  return errorFormNormalized;
};
